import { Modal } from './modal';
import { formsInit } from './forms';

const modal = new Modal();



if (document.querySelector('#regForm')) {
  var currentTab = 0; // Current tab is set to be the first tab (0)
  showTab(currentTab); // Display the current tab
  function showTab(n) {
    // console.log(n);
    // This function will display the specified tab of the form ...
    var x = document.getElementsByClassName('tab');

    document.querySelectorAll('.tab').forEach(tab => {
      // console.log(tab);
      tab.style.display = 'none';
    });

    x[n].style.display = 'block';
    // ... and fix the Previous/Next buttons:
    if (n === 0) {
      document.getElementById('prevBtn').style.display = 'none';
      
    } else {
      document.getElementById('prevBtn').style.display = 'inline';
    }
    if (n === (x.length - 1)) {
      document.getElementById('nextBtn').innerHTML = 'Submit';
      document.getElementById('nextBtn').type = 'submit';
    } else {
      document.getElementById('nextBtn').innerHTML = 'Next';
      document.getElementById('nextBtn').type = 'button';
    }
    // ... and run a function that displays the correct step indicator:
    if (n <= x.length) {
      fixStepIndicator(n);
    }
    
  }
  
  function nextPrev(n) {
    var x = document.getElementsByClassName('tab');
    if (n === 1 && !validateForm()) return false;
    
    x[currentTab].style.display = 'none';
    currentTab = currentTab + n;      
    if(currentTab > x.length-1) {
      currentTab = x.length-1;
      // currentTab = 0;

      let params; let data; let xhr; let obj;

      const ser = new URLSearchParams(Array.from(new FormData(document.querySelector('#regForm')))).toString();
      params = {
        action: 'send-brief',
        sendBrief: ser
      };
      
      data = new URLSearchParams(params).toString();
      xhr = new XMLHttpRequest();
      xhr.open('POST', 'ajax.html', true);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(data);
      // e.target.classList.add('loading');
      xhr.onload = function() {

        if (xhr.status !== 200) {
          console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
          currentTab = x.length-1;
        } else { 
          
          // ////////////// form reset
          document.querySelector('#regForm').reset(); 
          formsInit();
          const elems = document.querySelectorAll('.form_relative');
          [].forEach.call(elems, function(el) {
            el.classList.remove('is-active');
          });
          const elems2 = document.querySelectorAll('.box-for-files');
          [].forEach.call(elems2, function(el) {
            el.innerHTML = '';
          });
          // ////////////// end form reset
          // modalEmpty();
          modal.empty();
          obj = JSON.parse(xhr.response);
          modal.data(obj.modaltitle,obj.modaldata,obj.buttons);
          
          
          modal.active();
          currentTab = 0;
          showTab(currentTab);
        }
      };

     
    }
    showTab(currentTab);
   
  }
  
  function validateForm() {
    // This function deals with validation of the form fields
    var x, y, i, valid = true;
    x = document.getElementsByClassName('tab');
    y = x[currentTab].querySelectorAll('input,textarea');
    // A loop that checks every input field in the current tab:
    for (i = 0; i < y.length; i++) {
      // If a field is empty...
      // console.log(y[i].checkValidity(), y[i])
      // if ((y[i].value === '')&&(y[i].required === true)) {
      if (!y[i].checkValidity()) {
        // add an "invalid" class to the field:
        if (!y[i].classList.contains('invalid')) {
          y[i].className += ' invalid';
          // y[i].attributes = 'invalid';
        };

        // if (y[i].type === 'checkbox') {

        // } 
        
        // and set the current valid status to false:
        valid = false;
      }
    }
    // If the valid status is true, mark the step as finished and valid:
    if (valid) {
      document.getElementsByClassName('step')[currentTab].className += ' finish';
    }
    return valid; // return the valid status
  }
  
  function fixStepIndicator(n) {
    // This function removes the "active" class of all steps...
    var i, x = document.getElementsByClassName('step');
    for (i = 0; i < x.length; i++) {
      x[i].className = x[i].className.replace(' active', '');
    }
    //... and adds the "active" class to the current step:
    x[n].className += ' active';
  }
  
  
  
  document.addEventListener('click', function(e) {
    

    if (e.target.getAttribute('data-briefaction') === 'prev') {
      e.preventDefault();

      nextPrev(-1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
  
    };
    if (e.target.getAttribute('data-briefaction') === 'next') {
      e.preventDefault();

      nextPrev(1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
  
    }
    
  });
  
  
  const formtests = document.querySelectorAll('#regForm input:required');
  if (formtests) {
    formtests.forEach(formtest => {
      formtest.addEventListener('input', function() {
        this.classList.remove('invalid');
        if (document.querySelectorAll(`input[name="${this.name}"]`).length > 1) {
          document.querySelectorAll(`input[name="${this.name}"]`).forEach(item => {
            item.classList.remove('invalid');
          })
        }
      });
    });
  }
   
  


  let inputs;

  const fieldAVLeaders= document.querySelectorAll('.fielAVLeader');
  
  if (fieldAVLeaders) {
    fieldAVLeaders.forEach(fieldAVLeader => {
      fieldAVLeader.addEventListener('input', function() {
        if (fieldAVLeader.checked === true) {
          inputs = this.closest('.fieldAVParent').querySelectorAll('input, textarea, select');
          inputs.forEach(input => {
            if (input.disabled = true) {
              input.disabled = false;
            }
          });
        }else{
          inputs = this.closest('.fieldAVParent').querySelectorAll('input, textarea, select');
          inputs.forEach(input => {
            if (input.classList.contains('fielAVLeader')) {
              return;
            }
            input.disabled = true;
          });
        }
      });
        
      })

  }

  const fieldsetLeaders= document.querySelectorAll('.fieldsetLeader');
  
  if (fieldsetLeaders) {
    fieldsetLeaders.forEach(fieldsetLeader => {
      fieldsetLeader.addEventListener('input', function() {
        if (fieldsetLeader.checked === true) {
          inputs = this.closest('fieldset').querySelectorAll('input, textarea, select');
          inputs.forEach(input => {
            if (input.disabled = true) {
              input.disabled = false;
            }
          });
        }else{
          inputs = this.closest('fieldset').querySelectorAll('input, textarea, select');
          inputs.forEach(input => {
            if (input.classList.contains('fieldsetLeader')) {
              return;
            }
            input.disabled = true;
            // }
          });
        }
        
      });
    });
  }
















}



